"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTerminalNodeOptionsFilter = exports.buildListOperatorLabelMap = exports.HLQA_TASKS_LIST_FILTER_OPERATORS = void 0;
const graphql_1 = require("../../../../../__generated__/graphql");
const ui_components_1 = require("@groupby/ui-components");
exports.HLQA_TASKS_LIST_FILTER_OPERATORS = [
    ui_components_1.ListFilterOperatorTypes.IsAnyOf,
    ui_components_1.ListFilterOperatorTypes.IsNot,
];
const buildListOperatorLabelMap = (textOperatorLabelMap) => ({
    [ui_components_1.ListFilterOperatorTypes.IsAnyOf]: textOperatorLabelMap[ui_components_1.TextFilterOperatorTypes.Contains],
    [ui_components_1.ListFilterOperatorTypes.IsNot]: textOperatorLabelMap[ui_components_1.TextFilterOperatorTypes.DoesNotContain],
});
exports.buildListOperatorLabelMap = buildListOperatorLabelMap;
const buildTerminalNodeOptionsFilter = (query) => {
    var _a;
    const normalizedQuery = (_a = query === null || query === void 0 ? void 0 : query.trim()) !== null && _a !== void 0 ? _a : '';
    if (!normalizedQuery) {
        return { terminalNodesOnly: true };
    }
    return {
        terminalNodesOnly: true,
        title: {
            contains: normalizedQuery,
            mode: graphql_1.StringFilterMode.Insensitive,
        },
    };
};
exports.buildTerminalNodeOptionsFilter = buildTerminalNodeOptionsFilter;
